import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchActionDTO } from 'src/api/action-dto';
import { actionDTOFailure, actionDTOSuccess, ACTION_DTO, requestactionDTO } from 'src/store/action-dto/actions';

/* Customer Addresses */
function* actionDTO(action: AnyAction): SagaIterator {
    const { dto, successAction, successCallback } = action;
    yield put(requestactionDTO());

    const { error, response } = yield call(fetchActionDTO, dto.method, dto.endpoint);

    if (error) yield put(actionDTOFailure(error));
    else {
        yield put(actionDTOSuccess(response));
        if (successAction) yield put(successAction);
        if (successCallback) successCallback();
        const redirectUrl = response.data?.redirectUrl;
        if (typeof redirectUrl === 'string' && redirectUrl !== '') window.open(redirectUrl, '_blank');
    }
}

export function* generateactionDTOWatcher() {
    yield takeLatest(ACTION_DTO, actionDTO);
}
